<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { FairVariantCompareTray } from '@/ui/patterns/FairVariantCompare'
import { useVariantCompareStore } from '@/features/compare/store'
import { COMPARISON_ROUTE } from '@/router/routes'

const route = useRoute()
const compareStore = useVariantCompareStore()

const hideOnPage = computed(() => route.path === COMPARISON_ROUTE)

const items = computed(() => compareStore.items)

function handleClear() {
  compareStore.clear()
}
</script>

<template>
  <FairVariantCompareTray
    :items="items"
    :visible="!hideOnPage"
    @clear="handleClear"
  />
</template>
